import { render, staticRenderFns } from "./cusprocess.vue?vue&type=template&id=54ff4ba1&scoped=true"
import script from "./cusprocess.vue?vue&type=script&lang=js"
export * from "./cusprocess.vue?vue&type=script&lang=js"
import style0 from "./cusprocess.vue?vue&type=style&index=0&id=54ff4ba1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ff4ba1",
  null
  
)

export default component.exports